import { receiptPlainTextCols } from './format';
import type { ReceiptWidthMm } from './types';

/** Stack monospace del SO — no fuente de marca (ESC/POS usa la de la impresora). */
export const RECEIPT_FONT_FAMILY =
  'ui-monospace, SFMono-Regular, Menlo, Consolas, monospace';

export const RECEIPT_INK = '#111';

/** Separador compartido (texto plano + HTML). */
export const RECEIPT_SEPARATOR = '----------------';

export type ThermalPlainLineRole =
  | 'branch'
  | 'title'
  | 'subtitle'
  | 'legal'
  | 'meta'
  | 'sep'
  | 'code'
  | 'notes'
  | 'void'
  | 'subtotal'
  | 'total'
  | 'payment'
  | 'foot';

function pageMarginMm(widthMm: ReceiptWidthMm): number {
  if (widthMm === 58) return 2;
  if (widthMm === 80) return 4;
  return 3;
}

/** CSS para tickets browser (`wrapThermalPlainDocumentHtml`). */
export function receiptPlainDocumentCss(widthMm: ReceiptWidthMm): string {
  const margin = pageMarginMm(widthMm);
  const cols = receiptPlainTextCols(widthMm);
  return `
  @page { margin: ${margin}mm; size: ${widthMm}mm auto; }
  @media print {
    html {
      margin: 0 !important; padding: 0 !important; width: 100% !important; max-width: 100% !important;
    }
    body {
      margin-left: auto !important; margin-right: auto !important;
      padding: 0 !important; width: ${cols}ch !important; max-width: ${cols}ch !important;
    }
  }
  body {
    margin: 0 auto; padding: 0; width: ${cols}ch; max-width: ${cols}ch; box-sizing: border-box;
    font-family: ${RECEIPT_FONT_FAMILY};
    color: ${RECEIPT_INK};
  }
  .line { margin: 0; padding: 0; text-align: left; line-height: 1.3; word-break: break-word; max-width: ${cols}ch; }
  .line.branch { font-size: 12px; font-weight: 700; margin-bottom: 4px; }
  .line.title { font-size: 15px; font-weight: 800; margin-bottom: 2px; }
  .line.subtitle { font-size: 11px; margin-bottom: 2px; }
  .line.legal { font-size: 10px; margin-bottom: 4px; }
  .line.meta { font-size: 10px; margin-bottom: 1px; }
  .line.sep { font-size: 11px; margin: 6px 0; letter-spacing: -0.04em; }
  .line.code { font-size: 20px; font-weight: 800; margin-bottom: 4px; letter-spacing: 0.02em; }
  .line.notes { font-size: 12px; font-weight: 700; margin: 4px 0; }
  .line.void {
    font-size: 12px; font-weight: 800; margin: 4px 0;
    border: 2px solid ${RECEIPT_INK}; padding: 4px; text-align: center;
  }
  .line.subtotal { font-size: 11px; margin-top: 2px; }
  .line.total { font-size: 13px; font-weight: 800; margin-top: 4px; }
  .line.payment { font-size: 11px; margin-top: 1px; }
  .line.foot { font-size: 10px; margin-top: 6px; text-align: center; }
  pre.items {
    font-family: inherit; font-size: 11px; line-height: 1.35;
    margin: 0; padding: 0; text-align: left; white-space: pre-wrap;
    overflow: hidden; max-width: ${cols}ch; width: ${cols}ch; box-sizing: border-box;
  }
  .append { margin-top: 8px; }
  .append img { display: block; max-width: 100%; margin: 8px auto; }
  .append .caption { font-size: 10px; text-align: center; margin-top: 4px; }
`;
}
